import Layout from "@/layout";
export default {
  path: "/:pathMatch(.*)",
  name: "Layout",
  component: Layout,
  meta: {
    title: "",
    name: "firstHome",
  },
  children: [
    {
      path: "/",
      component: () =>
        import(
          /* webpackChunkName: "firstHome" */ "@/views/firstHome/HomeView.vue"
        ),
      name: "home",
      title: "首页",
    },

    {
      path: "/productView", //产品首页
      component: () =>
        import(/* webpackChunkName: "constRoutes" */ "@/views/productView.vue"),
      name: "productView",
      title: "产品首页",
    },
    {
      path: "/SupportView", //SUPPORT
      component: () =>
        import(/* webpackChunkName: "constRoutes" */ "@/views/SupportView.vue"),
      name: "SUPPORT",
      title: "SUPPORT",
    },
    {
      path: "/FinanceView", //SUPPORT
      component: () =>
        import(/* webpackChunkName: "constRoutes" */ "@/views/FinanceView.vue"),
      name: "FINANCE",
      title: "FINANCE",
    },

    {
      path: "/inquiry",
      name: "ContactView",
      title: "ContactView",
      component: () =>
        import(
          /* webpackChunkName: "constRoutes" */ "@/views/contactUs/index.vue"
        ),
    },

    {
      path: "/projectDetiil",
      name: "projectDetiil",
      title: "PRODUCT DETAIL",
      component: () =>
        import(/* webpackChunkName: "constRoutes" */ "@/views/project-info"),
    },

    {
      path: "/otherProducts",
      name: "otherProducts",
      title: "OTHER PRODUCTS",
      component: () =>
        import(/* webpackChunkName: "constRoutes" */ "@/views/productView"),
    },

    {
      path: "/ContactView",
      name: "contactUs",
      title: "CONTACT US",
      component: () =>
        import(/* webpackChunkName: "constRoutes" */ "@/views/contactUs"),
    },

    {
      path: "/PolicyView",
      name: "PrivacyPolicy",
      title: "PrivacyPolicy",
      component: () => import("@/views/support/privacy-policy.vue"),
    },
    {
      path: "/serviceView",
      name: "serviceView",
      title: "service-view",
      component: () => import("@/views/support/serviceView.vue"),
    },
    {
      path: "/AboutView",
      name: "about",
      title: "About-US",
      component: () => import("@/views/about-us.vue"),
    },
    {
      path: "/inquiry/new-inquiry",
      name: "newInquiry",
      title: "New-Inquiry",
      component: () => import("@/views/newInquiry.vue"),
    },
    {
      path: "/detailsView",
      name: "detailsView",
      title: "details-View",
      component: () => import("@/views/detailsView.vue"),
    },
  ],
};
